var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardModeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.99988,
    y: 8,
    width: 7,
    height: 7,
    rx: 1.33333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9999,
    y: 8,
    width: 7,
    height: 7,
    rx: 1.33333
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9999,
    y: 8,
    width: 7,
    height: 7,
    rx: 1.33333
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.99988,
    y: 17,
    width: 7,
    height: 7,
    rx: 1.33333
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9999,
    y: 17,
    width: 7,
    height: 7,
    rx: 1.33333
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9999,
    y: 17,
    width: 7,
    height: 7,
    rx: 1.33333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardModeIcon);
export default __webpack_public_path__ + "static/media/card_mode_icon.3d93a86a42d8472b270ba2957309c3b1.svg";
export { ForwardRef as ReactComponent };